import { combineReducers } from 'redux';
import { user, userIsLoading } from './login';
import { errorMessage, jobs, links } from './common';
import {intlReducer} from 'react-intl-redux'

export default combineReducers({
  intl: intlReducer,
  user,
  jobs,
  links,
  userIsLoading,
  errorMessage,
});



// WEBPACK FOOTER //
// ./src/reducers/index.jsx